import { profileImageFromRecord } from './profileDisplaySummary';

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

/** Read a worker photo reference from PATCH /profile/update-worker responses. */
export function extractWorkerProfileImageFromMutation(data: unknown): string | null {
  if (!isPlainObject(data)) {
    return null;
  }
  const direct = profileImageFromRecord(data);
  if (direct) {
    return direct;
  }
  for (const key of ['worker', 'data', 'result', 'user', 'profile']) {
    const nested = data[key];
    if (isPlainObject(nested)) {
      const image = profileImageFromRecord(nested);
      if (image) {
        return image;
      }
    }
  }
  return null;
}
